// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2WcBK","actionsCol":"EnrolledClinics_actionsCol__DZ2CX"};